import Vue from 'vue'
import Router from 'vue-router'
import UserSignIn from './views/UserSignIn'
import UserSignUp from './views/UserSignUp'
import UserReset from './views/UserReset'

import Groups from './views/Groups'
import Group from './views/Group'
import GroupVersion from './views/GroupVersion'

import Device from './views/Device'
import Statistics from './views/Statistics'
import Settings from './views/Settings'
import Report from './views/Report'

import Shipments from './views/Shipments'
import Shipment from './views/Shipment'
import Complete from './views/Complete'

import Orders from './views/Orders'
import Order from './views/Order'

import TIDLogon from './views/TidLogon'

import Log from './views/Log'

import Dashboard from './views/Dashboard'

import Transactions from './views/Transaction'

import DataOut from './views/DataOut'
import DeviceVersion from './views/DeviceVersion'
import DataExport from "./views/DataExport"
import LoadMACKeys from "./views/LoadMACKeys"

Vue.use(Router);

export default new Router({
  routes: [
    { path: '/', component: UserSignIn },
    { path: '/signin', component: UserSignIn },
    { path: '/signup', component: UserSignUp },
    { path: '/reset', component: UserReset },

    { path: '/home', component: Groups },
    { path: '/groups', component: Groups },
    { path: '/group/:id', component: Group },

    { path: '/group_version/:id', component: GroupVersion },

    { path: '/device/:group_id/:device_id', component: Device },
    { path: '/transaction/:group_id/:device_id/:transaction_uuid', component: Transactions },
    { path: '/stats/:group_id/:device_id', component: Statistics },
    { path: '/settings/:group_id/:device_id', component: Settings },
    { path: '/report/:group_id/:device_id', component: Report },

    { path: '/orders/:group_id', component: Orders },
    { path: '/order/:group_id', component: Order },
    { path: '/order/:group_id/:order_id', component: Order },

    { path: '/tidlogon', component: TIDLogon },
    { path: '/shipping', component: Shipments },
    { path: '/complete', component: Complete },
    { path: '/shipment/:order_id', component: Shipment },

    { path: '/log/:group_id/:device_id', component: Log },

    { path: '/dashboard', component: Dashboard },

    { path: '/data_out/:group_id', component: DataOut },
    { path: '/device_versions/:group_id', component: DeviceVersion },
    { path: '/data_export', component: DataExport },
    { path: '/load_macs', component: LoadMACKeys }
  ]
})
